import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class AccountSettingsNavigationModule {
}
AccountSettingsNavigationModule.ɵfac = function AccountSettingsNavigationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountSettingsNavigationModule)(); };
AccountSettingsNavigationModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AccountSettingsNavigationModule });
AccountSettingsNavigationModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
